/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Outline pencil (14×14). Color via `currentColor`. */
const PencilIcon = ({
  size = 14,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M2.33325 11.6667H4.66659L10.4999 5.83333L8.16658 3.5L2.33325 9.33333V11.6667"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
    />
    <path d="M8.16675 3.5L10.5001 5.83333" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" />
  </svg>
);

PencilIcon.propTypes = iconPropTypes;

export default PencilIcon;
